<template>
  <iq-card class-name="iq-card-block iq-card-stretch iq-card-height">
    <loader v-if="!isContentLoaded" :is-visible="!isContentLoaded"></loader>
    <div v-if="isContentLoaded">
      <div class="iq-card-header d-flex justify-content-between">
        <apex-chart-header :disable-range-selection="true" :header="header"></apex-chart-header>
      </div>
      <div class="card-body iq-card-body p-1" style="position: relative;">
        <div id="chartUniqueId">
          <apexchart v-if="isContentLoaded" type="area" height="350" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
    </div>
  </iq-card>
</template>

<script>
    import Loader from "../../components/shared/Loader";
    import ApexChartHeader from "../../components/apexCharts/ApexChartHeader";

    import ChartService from "../../services/chart";
    import "../../plugins/apexchart";

    export default {
        components: {
            Loader,
            ApexChartHeader
        },
        props: {
            dataUrl: String,
            dataObject: Object
        },
        data() {
            return {
                date: { startDate: '', endDate: '' },
                isContentLoaded: false,
                header: '',
                series: [{
                    name: '',
                    data: []
                }],
                chartOptions: {
                    chart: {
                        type: 'area',
                        height: 350,
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: true,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                            }
                        },
                        defaultLocale: 'tr',
                        locales: [{
                            name: 'tr',
                            options: {
                                toolbar: {
                                    "exportToSVG": this.$t('DownloadSvg'),
                                    "exportToPNG": this.$t('DownloadPng'),
                                    "menu": this.$t('Menu'),
                                    "selection": this.$t('Selection'),
                                    "selectionZoom": this.$t('SelectionZoom'),
                                    "zoomIn": this.$t('ZoomIn'),
                                    "zoomOut": this.$t('zoomOut'),
                                    "pan": this.$t('Panning'),
                                    "reset": this.$t('ResetZoom')
                                }
                            }
                        }]
                  },
                    colors: ["#089bab", "#fca162"],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        categories: []
                    },
                    yaxis: {
                        opposite: false
                    },
                    legend: {
                        horizontalAlign: 'left'
                    },
                },
            }
        },
        methods: {
            getData() {
                ChartService.getChartData(this.url)
                    .then(response => {
                        if (response) {
                            this.setData(response);
                        }
                    });
            },
            setData(filledChartData) {
                let $this = this;
                $this.series = filledChartData.series;
                for (var i = 0; i < $this.series.length; i++) {
                    $this.series[i].name = $this.$t($this.series[i].name);
                }
                $this.header = this.$t(filledChartData.chartHeader);

                if (filledChartData.currencySymbol) {
                    $this.header += " (" + filledChartData.currencySymbol + ")"
                }

                $this.chartOptions.xaxis.categories = filledChartData.xaxis.categories;
                $this.isContentLoaded = true;
            }
        },
        watch: {
            date: function (newDate) {
                if (newDate && newDate.length > 0)
                    this.getData()
            },
            chartData: function () {
                this.setData(this.chartData);
            },
            url: {
                handler: function (value) {
                    if (value)
                        this.getData();
                },
                immediate: true
            }
        },
        computed: {
            chartUniqueId: function () {
                return "apexAreaChart"
            },
            chartData: function () {
                return this.dataObject;
            },
            url: function () {
                return this.dataUrl;
            }
        },
        mounted: function () {
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .apexcharts-menu-item.exportCSV {
        display: none;
    }

    ::v-deep .apexcharts-menu.apexcharts-menu-open {
        min-width: 82px !important;
    }
</style>
